import { Component, For } from 'solid-js';
import { useLanguage, Language } from '../i18n/LanguageContext';

const languages: { code: Language; name: string; flag: string }[] = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'zh', name: '中文', flag: '🇨🇳' }
];

const LanguageSelector: Component = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div class="language-selector">
      <select
        class="language-select"
        value={language()}
        onChange={(e) => setLanguage(e.currentTarget.value as Language)}
      >
        <For each={languages}>
          {(lang) => (
            <option value={lang.code}>
              {lang.flag} {lang.name}
            </option>
          )}
        </For>
      </select>
    </div>
  );
};

export default LanguageSelector;
